export default "__VITE_ASSET__4c2d6002__"